import { CALL_API } from '../middleware/api'

// ─── AVAILABILITY ─────────────────────────────────────────────
export const TIME_AVAILABILITY_REQUEST = 'TIME_AVAILABILITY_REQUEST'
export const TIME_AVAILABILITY_SUCCESS = 'TIME_AVAILABILITY_SUCCESS'
export const TIME_AVAILABILITY_FAILURE = 'TIME_AVAILABILITY_FAILURE'

export function fetchTimeAvailability(token) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `qrstime/availability/${token}`,
      authenticated: true,
      types: [TIME_AVAILABILITY_REQUEST, TIME_AVAILABILITY_SUCCESS, TIME_AVAILABILITY_FAILURE]
    }
  }
}

// ─── DISPONIBILITY ────────────────────────────────────────────
export const TIME_DISPONIBILITY_REQUEST = 'TIME_DISPONIBILITY_REQUEST'
export const TIME_DISPONIBILITY_SUCCESS = 'TIME_DISPONIBILITY_SUCCESS'
export const TIME_DISPONIBILITY_FAILURE = 'TIME_DISPONIBILITY_FAILURE'

export function fetchTimeDisponibility(token) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `qrstime/disponibility/${token}`,
      authenticated: true,
      types: [TIME_DISPONIBILITY_REQUEST, TIME_DISPONIBILITY_SUCCESS, TIME_DISPONIBILITY_FAILURE]
    }
  }
}

// ─── PREBOOKING ───────────────────────────────────────────────
export const TIME_PREBOOKING_REQUEST = 'TIME_PREBOOKING_REQUEST'
export const TIME_PREBOOKING_SUCCESS = 'TIME_PREBOOKING_SUCCESS'
export const TIME_PREBOOKING_FAILURE = 'TIME_PREBOOKING_FAILURE'

export function postTimePrebooking(prebooking) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/prebooking',
      authenticated: true,
      body: JSON.stringify(prebooking),
      types: [TIME_PREBOOKING_REQUEST, TIME_PREBOOKING_SUCCESS, TIME_PREBOOKING_FAILURE]
    }
  }
}

// ─── CANCEL PREBOOKING ────────────────────────────────────────
export const TIME_CANCEL_PREBOOKING_REQUEST = 'TIME_CANCEL_PREBOOKING_REQUEST'
export const TIME_CANCEL_PREBOOKING_SUCCESS = 'TIME_CANCEL_PREBOOKING_SUCCESS'
export const TIME_CANCEL_PREBOOKING_FAILURE = 'TIME_CANCEL_PREBOOKING_FAILURE'

export function postTimeCancelPrebooking(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/cancelprebooking',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_CANCEL_PREBOOKING_REQUEST, TIME_CANCEL_PREBOOKING_SUCCESS, TIME_CANCEL_PREBOOKING_FAILURE]
    }
  }
}
// ─── UPDATE LOCKER INFO (before payment) ─────────────────────
export const TIME_UPDATE_LOCKER_INFO_REQUEST = 'TIME_UPDATE_LOCKER_INFO_REQUEST'
export const TIME_UPDATE_LOCKER_INFO_SUCCESS = 'TIME_UPDATE_LOCKER_INFO_SUCCESS'
export const TIME_UPDATE_LOCKER_INFO_FAILURE = 'TIME_UPDATE_LOCKER_INFO_FAILURE'

export function postTimeUpdateLockerInfo(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/updatelockerinfo',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_UPDATE_LOCKER_INFO_REQUEST, TIME_UPDATE_LOCKER_INFO_SUCCESS, TIME_UPDATE_LOCKER_INFO_FAILURE]
    }
  }
}
// ─── RENT (after payment) ─────────────────────────────────────
export const TIME_RENT_REQUEST = 'TIME_RENT_REQUEST'
export const TIME_RENT_SUCCESS = 'TIME_RENT_SUCCESS'
export const TIME_RENT_FAILURE = 'TIME_RENT_FAILURE'

export function postTimeRent(rental) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/rent',
      authenticated: true,
      body: JSON.stringify(rental),
      types: [TIME_RENT_REQUEST, TIME_RENT_SUCCESS, TIME_RENT_FAILURE]
    }
  }
}

// ─── ACCESS (find rented locker) ──────────────────────────────
export const TIME_ACCESS_REQUEST = 'TIME_ACCESS_REQUEST'
export const TIME_ACCESS_SUCCESS = 'TIME_ACCESS_SUCCESS'
export const TIME_ACCESS_FAILURE = 'TIME_ACCESS_FAILURE'

export function postTimeAccess(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/access',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_ACCESS_REQUEST, TIME_ACCESS_SUCCESS, TIME_ACCESS_FAILURE]
    }
  }
}

// ─── OPEN (trigger door open) ─────────────────────────────────
export const TIME_OPEN_REQUEST = 'TIME_OPEN_REQUEST'
export const TIME_OPEN_SUCCESS = 'TIME_OPEN_SUCCESS'
export const TIME_OPEN_FAILURE = 'TIME_OPEN_FAILURE'

export function postTimeOpen(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/open',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_OPEN_REQUEST, TIME_OPEN_SUCCESS, TIME_OPEN_FAILURE]
    }
  }
}

// ─── OPEN STATUS (poll) ───────────────────────────────────────
export const TIME_OPEN_STATUS_REQUEST = 'TIME_OPEN_STATUS_REQUEST'
export const TIME_OPEN_STATUS_SUCCESS = 'TIME_OPEN_STATUS_SUCCESS'
export const TIME_OPEN_STATUS_FAILURE = 'TIME_OPEN_STATUS_FAILURE'

export function fetchTimeOpenStatus(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `qrstime/open-status/${id}`,
      authenticated: true,
      types: [TIME_OPEN_STATUS_REQUEST, TIME_OPEN_STATUS_SUCCESS, TIME_OPEN_STATUS_FAILURE]
    }
  }
}

// ─── FINALIZE (open & free locker) ────────────────────────────
export const TIME_FINALIZE_REQUEST = 'TIME_FINALIZE_REQUEST'
export const TIME_FINALIZE_SUCCESS = 'TIME_FINALIZE_SUCCESS'
export const TIME_FINALIZE_FAILURE = 'TIME_FINALIZE_FAILURE'

export function postTimeFinalize(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/finalize',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_FINALIZE_REQUEST, TIME_FINALIZE_SUCCESS, TIME_FINALIZE_FAILURE]
    }
  }
}

// ─── EXTEND (buy more time) ───────────────────────────────────
export const TIME_EXTEND_REQUEST = 'TIME_EXTEND_REQUEST'
export const TIME_EXTEND_SUCCESS = 'TIME_EXTEND_SUCCESS'
export const TIME_EXTEND_FAILURE = 'TIME_EXTEND_FAILURE'

export function postTimeExtend(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/extend',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_EXTEND_REQUEST, TIME_EXTEND_SUCCESS, TIME_EXTEND_FAILURE]
    }
  }
}

// ─── REDSYS (payment initiation) ─────────────────────────────────────
export const TIME_REDSYS_REQUEST = 'TIME_REDSYS_REQUEST'
export const TIME_REDSYS_SUCCESS = 'TIME_REDSYS_SUCCESS'
export const TIME_REDSYS_FAILURE = 'TIME_REDSYS_FAILURE'

export function postRedsys(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/redsys',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_REDSYS_REQUEST, TIME_REDSYS_SUCCESS, TIME_REDSYS_FAILURE]
    }
  }
}

// ─── REDSYS GET PARAMETERS (verify payment) ──────────────────────────
export const TIME_REDSYS_GET_PARAMS_REQUEST = 'TIME_REDSYS_GET_PARAMS_REQUEST'
export const TIME_REDSYS_GET_PARAMS_SUCCESS = 'TIME_REDSYS_GET_PARAMS_SUCCESS'
export const TIME_REDSYS_GET_PARAMS_FAILURE = 'TIME_REDSYS_GET_PARAMS_FAILURE'

export function postRedsysGetParams(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/redsys-get-parameters',
      authenticated: true,
      body: JSON.stringify(data),
      types: [TIME_REDSYS_GET_PARAMS_REQUEST, TIME_REDSYS_GET_PARAMS_SUCCESS, TIME_REDSYS_GET_PARAMS_FAILURE]
    }
  }
}

// ─── CUSTOMER (fetch customer data for invoice) ───────────────────────
export const TIME_CUSTOMER_REQUEST = 'TIME_CUSTOMER_REQUEST'
export const TIME_CUSTOMER_SUCCESS = 'TIME_CUSTOMER_SUCCESS'
export const TIME_CUSTOMER_FAILURE = 'TIME_CUSTOMER_FAILURE'

export function fetchCustomer(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `qrstime/customer/${id}`,
      authenticated: true,
      types: [TIME_CUSTOMER_REQUEST, TIME_CUSTOMER_SUCCESS, TIME_CUSTOMER_FAILURE]
    }
  }
}

// ─── SALE (register time-rental sale) ────────────────────────────────
export const TIME_SALE_REQUEST = 'TIME_SALE_REQUEST'
export const TIME_SALE_SUCCESS = 'TIME_SALE_SUCCESS'
export const TIME_SALE_FAILURE = 'TIME_SALE_FAILURE'

export function postQrsale(sale) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'qrstime/sale',
      authenticated: true,
      body: JSON.stringify(sale),
      types: [TIME_SALE_REQUEST, TIME_SALE_SUCCESS, TIME_SALE_FAILURE]
    }
  }
}
